module.exports = __webpack_public_path__ + "img/group1.dfe48be5.svg";